import {
	ASSEMBLY_TECHMAP_OPERATION_PATH,
	EngineerValidateSuccess,
	PREFORM_TECHMAP_OPERATION_PATH,
	Stub,
} from '@/shared';
import { AssemblyOperationResponse } from '@/shared/state/api/swagger';
import { Button, chakra } from '@chakra-ui-kraud/react';
import { useCallback, useState } from 'react';
import { generatePath, useLocation, useNavigate, useParams } from 'react-router-dom';
import { CancelOperationsAlertProps } from './alert.types';
import { OperationUnfilled } from './operation-unfilled';

export const SkippedOperationsAlertProduct = ({
	handleSkipOperations,
	handleCancelOperations,
}: CancelOperationsAlertProps) => {
	return (
		<Stub
			icon={<EngineerValidateSuccess />}
			header="Операция заполнена"
			label={
				<p>
					Мы сохранили данные о заполненной операции, но вы также пропустили несколько операций. Отмените их
					или оставьте не заполненными.
				</p>
			}
			footer={
				<chakra.div width="100%" display="flex" flexDirection="column" gap="12px">
					<Button variant="solid" width="100%" onClick={handleCancelOperations}>
						Перейти к отмене операций
					</Button>
					<Button variant="outline" width="100%" onClick={handleSkipOperations}>
						Оставить незаполненными
					</Button>
				</chakra.div>
			}
		/>
	);
};

export const SkippedOperationsAlert = () => {
	const navigate = useNavigate();
	const [showUnfilledOperation, setShowUnfilledOperation] = useState(false);
	const { state } = useLocation();
	const { skippedOperations } = (state as { skippedOperations: AssemblyOperationResponse[] }) ?? {};
	const { assemblyTechMapId, preformTechMapId } = useParams();
	const techMapType = assemblyTechMapId ? 'assembly' : 'preform';

	const handleFillOperations = useCallback(() => {
		if (techMapType === 'assembly') {
			navigate(
				generatePath(ASSEMBLY_TECHMAP_OPERATION_PATH, {
					assemblyTechMapId: assemblyTechMapId ?? '',
				}),
			);
		} else {
			navigate(
				generatePath(PREFORM_TECHMAP_OPERATION_PATH, {
					preformTechMapId: preformTechMapId ?? '',
				}),
			);
		}
	}, [assemblyTechMapId, preformTechMapId, techMapType]);

	const handleSkipOperations = useCallback(() => {
		setShowUnfilledOperation(true);
	}, [skippedOperations]);

	if (showUnfilledOperation) {
		const lastOperation = skippedOperations[skippedOperations.length - 1];

		return <OperationUnfilled stepId={lastOperation?.step_id} operationName={lastOperation?.name} />;
	}

	return (
		<Stub
			icon={<EngineerValidateSuccess />}
			header="Операция заполнена"
			label={
				<p>
					Мы сохранили данные о заполненной операции, но вы также пропустили несколько операций. Перейдите к
					их заполнению или оставьте не заполненными.
				</p>
			}
			footer={
				<chakra.div width="100%" display="flex" flexDirection="column" gap="12px">
					<Button variant="solid" width="100%" onClick={handleFillOperations}>
						Перейти к заполнению
					</Button>
					<Button variant="outline" width="100%" onClick={handleSkipOperations}>
						Оставить незаполненными
					</Button>
				</chakra.div>
			}
		/>
	);
};
